import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const FIELD_SEPARATOR = ' ';

const getDefaultFormattedData = () => ({
    disparo1Tajo: '',
    disparo1Check: '',
    disparo2Tajo: '',
    disparo2Check: '',
    disparo1Nivel:'',
    disparo2Nivel:'',
    disparo1Hora: '',
    disparo2Hora: '',
    fecha: '',
});

const getResults = (dataDB) => {
    const results = {};
    dataDB.forEach((data, index) => {
        results[index] = data.Text;
    });
    return results;
}

const getFormattedData = (results) => ({
    disparo1Tajo: results[0]?.trim() ?? ' ',
    disparo1Check: results[0]?.trim() === 'SIN -' ? false : !!results[0]?.trim(),
    disparo2Tajo: results[1]?.trim() ?? '',
    disparo2Check: results[1]?.trim() === 'DISP ARO' ? false : !!results[1]?.trim(),
    disparo1Nivel: results[2]?.trim(),
    disparo2Nivel: results[3]?.trim(),
    disparo1Hora: results[4]?.trim(),
    disparo2Hora: results[5]?.trim(),
    fecha: dayjs(results[6]?.trim(), "YYYY-MM-DD").format("DD-MM-YYYY"),

    

});

export const formatWebData = (dataDB = {}) => {
    try {
        if (Object.entries(dataDB).length === 0) {
            return getDefaultFormattedData();
        } else {
            const results = getResults(dataDB);
            return getFormattedData(results);
        }
    } catch (error) {
        console.error('Error en formatData:', error);
        return getDefaultFormattedData();
    }
}